import StickyPageHeader from '../components/common/StickyPageHeader';
import UserList from '../components/lists/UserList';
import { useCarriers, useUsers } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminUsersPage = ({ disableLayout, routes }) => {
  const { allCarriers } = useCarriers();
  const { allUsers } = useUsers();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / Users" />
      <UserList carriers={allCarriers} id="users" users={allUsers} />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminUsersPage;
